export const ANOKINA_CUP_ML = 200;

export const MEASURE_DISCLAIMER =
  "Все значения ориентировочные. Для точных технологических и финансовых расчётов используй весы.";

export const MEASURE_STATE = Object.freeze({
  READY: "READY",
  APPROXIMATE: "APPROXIMATE_MEASURE",
  REQUIRES_DECISION: "REQUIRES_DECISION",
});

const tableRow = (canonical_ingredient, tsp = null, tbsp = null, cup = null, aliases = []) =>
  Object.freeze({ canonical_ingredient, tsp, tbsp, cup, aliases: Object.freeze(aliases) });

/* Approved MASTER TABLE v1. Every cell is explicit; missing cells stay null. */
export const VERIFIED_MEASURE_TABLE = Object.freeze([
  tableRow("Пшеничная мука", 2.5, 7.5, 100),
  tableRow("Хлебная мука", 2.5, 7.5, 100),
  tableRow("Спельтовая мука", 2.1, 6.2, 83),
  tableRow("Миндальная мука", 2, 6, 80),
  tableRow("Кокосовая мука", 2.7, 8, 107),
  tableRow("Овсяная мука", 1.9, 5.8, 77),
  tableRow("Амарантовая мука", 2.1, 6.4, 86),
  tableRow("Гречневая мука", 2.5, 7.5, 100),
  tableRow("Тапиоковый крахмал", 2.4, 7.1, 94),
  tableRow("Кукурузный крахмал", 2.3, 7, 93),
  tableRow("Сахар белый", 4.1, 12.4, 165),
  tableRow("Сахар коричневый", 4.4, 13.3, 178),
  tableRow("Сахар кокосовый", 3.2, 9.6, 128),
  tableRow("Демерара", 4.6, 13.8, 183),
  tableRow("Турбинадо", 3.8, 11.3, 150),
  tableRow("Сахарная пудра", 2.4, 7.1, 94),
  tableRow("Какао-порошок", 1.8, 5.3, 70),
  tableRow("Сливочное масло", 4.7, 14.1, 188),
  tableRow("Растительное масло", 4.1, 12.4, 165),
  tableRow("Оливковое масло", 4.2, 12.5, 167),
  tableRow("Кокосовое масло", 4.7, 14.1, 188),
  tableRow("Сливки 33–36%", 4.7, 14.2, 189),
  tableRow("Сметана", 4.7, 14.2, 189),
  tableRow("Сливочно-творожный сыр", 4.7, 14.2, 189),
  tableRow("Кокосовое молоко", 5, 15.1, 201),
  tableRow("Кокосовые сливки", 5.9, 17.8, 237),
  tableRow("Сгущённое молоко", 6.5, 19.5, 260),
  tableRow("Мёд", 7, 21, 280),
  tableRow("Глюкозный сироп", 6.5, 19.5, 260),
  tableRow("Меласса", 7.1, 21.3, 283),
  tableRow("Кленовый сироп", 6.5, 19.5, 260),
  tableRow("Сироп агавы", 7, 21, 280),
  tableRow("Арахисовая паста", 5.6, 16.9, 225),
  tableRow("Миндальная паста", 5.7, 17, 227),
  tableRow("Фундучное пралине / паста", 6.5, 19.5, 260),
  tableRow("Тахини", 5.3, 16, 213),
  tableRow("Кокосовая стружка", 1.8, 5.3, 71),
  tableRow("Грецкие орехи", 2.4, 7.1, 94),
  tableRow("Миндаль", 3, 8.9, 118),
  tableRow("Фундук", 3, 8.9, 118),
  tableRow("Макадамия", 3.1, 9.3, 124),
  tableRow("Шоколадные капли", 3.7, 11.1, 148),
  tableRow("Ванильный экстракт", 4.7, 14, 187, ["Ванильного экстракта", "Экстракт ванили"]),
  tableRow("Лимонный сок", 4.7, 14, 187, ["Лимонного сока", "Сок лимона"]),
  tableRow("Вода / кипяток", 5, 15, 200, ["Вода", "Кипяток"]),
  tableRow("Разрыхлитель", 4),
  tableRow("Сода", 6),
  tableRow("Сухие дрожжи", 3),
  tableRow("Соль столовая", 6, null, null, ["Столовая соль"]),
  tableRow("Сок лайма", null, 14, null, ["Лаймовый сок"]),
  tableRow("Апельсиновый сок", null, 14),
  tableRow("Ванильная паста", null, 14),
]);

export const UNVERIFIED_MEASURE_INGREDIENTS = Object.freeze([
  "Рисовый крахмал", "Картофельный крахмал", "Лимонная кислота", "Корица",
  "Имбирь", "Кардамон", "Мускатный орех", "Гвоздика", "Бадьян", "Анис",
  "Инвертный сироп", "Сироп топинамбура", "Варёное сгущённое молоко",
  "Мягкая карамель", "Фисташковая паста", "Паста кешью", "Йогурт конкретной жирности",
]);

const READY_UNITS = new Set(["g", "kg", "ml", "l", "pcs"]);
const HOUSEHOLD_UNITS = new Set(["tsp", "tbsp", "cup", "pinch", "handful", "taste"]);
const CONVERTIBLE_UNITS = new Set(["tsp", "tbsp", "cup"]);

export const normalizeDirectoryIngredient = (value) =>
  String(value || "").trim().toLocaleLowerCase("ru").replace(/ё/g, "е").replace(/\s+/g, " ");

const findTableRow = (ingredientName) => {
  const key = normalizeDirectoryIngredient(ingredientName);
  return VERIFIED_MEASURE_TABLE.find((candidate) =>
    [candidate.canonical_ingredient, ...candidate.aliases]
      .some((name) => normalizeDirectoryIngredient(name) === key)
  ) || null;
};

export const getVerifiedConversion = (ingredientName, sourceUnit, sourceQuantity) => {
  const quantity = Number(sourceQuantity);
  if (!Number.isFinite(quantity) || quantity <= 0 || !CONVERTIBLE_UNITS.has(sourceUnit)) return null;
  const entry = findTableRow(ingredientName);
  const perUnit = entry?.[sourceUnit];
  if (!entry || !Number.isFinite(perUnit)) return null;
  const metricQuantity = quantity * perUnit;
  return {
    canonical_ingredient: entry.canonical_ingredient,
    source_unit: sourceUnit,
    source_quantity: 1,
    approx_metric_quantity: perUnit,
    metric_unit: "g",
    verified: true,
    source_quantity_requested: quantity,
    metric_quantity: Number(metricQuantity.toFixed(4)),
  };
};

export const getIngredientMeasureState = (ingredient) => {
  if (READY_UNITS.has(ingredient?.unit)) return { state: MEASURE_STATE.READY, suggestion: null };
  if (ingredient?.name && !ingredient?.unit) {
    return { state: MEASURE_STATE.APPROXIMATE, suggestion: null, requires_manual_weight: true };
  }
  const suggestion = getVerifiedConversion(ingredient?.name, ingredient?.unit, ingredient?.amount);
  if (HOUSEHOLD_UNITS.has(ingredient?.unit)) {
    return { state: MEASURE_STATE.APPROXIMATE, suggestion, requires_manual_weight: !suggestion };
  }
  return { state: MEASURE_STATE.REQUIRES_DECISION, suggestion: null };
};

export const applyMetricResolution = (ingredient, grams) => {
  const value = Number(String(grams).replace(",", "."));
  if (!Number.isFinite(value) || value <= 0) return null;
  return { ...ingredient, amount: value, unit: "g" };
};

export const formatMeasureNumber = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return String(Number(number.toFixed(2))).replace(".", ",");
};

export const verifiedDirectoryRows = () => VERIFIED_MEASURE_TABLE.map((entry) => ({
  ingredient: entry.canonical_ingredient,
  tsp: entry.tsp,
  tbsp: entry.tbsp,
  cup: entry.cup,
}));

export const MEASURE_CONVERSION_DIRECTORY = Object.freeze(
  VERIFIED_MEASURE_TABLE.flatMap((entry) => ["tsp", "tbsp", "cup"]
    .filter((unit) => Number.isFinite(entry[unit]))
    .map((unit) => Object.freeze({
      canonical_ingredient: entry.canonical_ingredient,
      source_unit: unit,
      source_quantity: 1,
      approx_metric_quantity: entry[unit],
      metric_unit: "g",
      verified: true,
    })))
);
